export const TARIFF_COOKIE_NAME = 'tariff';
export const AJAX_ACTION_GET_CARD = 'yarus_get_tariff_card';

export const EVENT_TARIFFS_BEFORE_INIT = 'Tariffs:before-init';
export const EVENT_TARIFFS_BEFORE_COOKIE_CHANGED = 'Tariffs:before-cookie-changed';
export const EVENT_TARIFFS_COOKIE_CHANGED = 'Tariffs:cookie-changed';

export const EVENT_TARIFF_CARD_INITIALIZED = 'TariffCard:initialized';
export const EVENT_TARIFF_CARD_CLICK = 'TariffCard:click';
export const EVENT_TARIFF_CARD_UPDATED = 'TariffCard:updated';
export const EVENT_TARIFF_CARD_RECALCULATED = 'TariffCard:recalculated';
export const EVENT_TARIFF_CARD_RENDERED = 'TariffCard:rendered';
